import { DocumentNode } from "@apollo/client";

import { showDeleteConfirmation } from "components/ApiKeys/DeleteConfirmation";
import { showResetConfirmation } from "components/ApiKeys/ResetConfirmation";
import DropdownMenuEllipsis from "ds/components/DropdownMenu/Ellipsis";
import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { ApiKey, ApiKeyType } from "types/generated";

type ApiKeysListItemDropdownProps = {
  handleApiKeyDetailsClick: () => void;
  name: string;
  id: string;
  type: ApiKey["type"];
  refetchQueriesOnDelete?: DocumentNode[];
};

const ApiKeysListItemDropdown = ({
  handleApiKeyDetailsClick,
  refetchQueriesOnDelete,
  name,
  id,
  type,
}: ApiKeysListItemDropdownProps) => {
  const onDeleteClick = () => {
    showDeleteConfirmation({ name, id, refetchQueriesOnDelete });
  };

  const onResetClick = () => {
    showResetConfirmation({ name, id });
  };

  return (
    <DropdownMenuEllipsis tooltip="API key actions">
      <DropdownMenuItem onAction={handleApiKeyDetailsClick}>Access details</DropdownMenuItem>
      {type === ApiKeyType.Secret && (
        <DropdownMenuItem onAction={onResetClick}>Reset</DropdownMenuItem>
      )}
      <DropdownMenuItem onAction={onDeleteClick} danger>
        Delete
      </DropdownMenuItem>
    </DropdownMenuEllipsis>
  );
};

export default ApiKeysListItemDropdown;
